const INIT_PRODUCTS = {
  schoolLicense: {
    school: {
      name: null,
      adresses: [
        {
          street: null,
          zipCode: null,
          city: null,
          invoice: false,
        },
      ],
    },
    license: {
      programLicenses: [
        {
          id: 0,
          name: null,
          price: 0,
          addedDate: null,
          courses: [
            {
              id: 0,
              name: null,
              price: 0,
              addedDate: null,
            },
          ],
        },
      ],
    },
    name: null,
    price: 0,
    currency: null,
    validTo: null,
  },
  loading: false,
  error: null,
};

export function productsReducer(state = INIT_PRODUCTS, action = {}) {
  // PLEASE NOTE:
  // below actions are unused
  // kept for instance - Ajinkya
  switch (action.type) {
    case "FETCH_PRODUCTS_BEGIN": {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case "FETCH_PRODUCTS_FULFILLED": {
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    }
    case "FETCH_PRODUCTS_REJECTED": {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: [],
      };
    }
    default: {
      return { ...state };
    }
  }
}

const INIT_STUDENTS_LICENSES = {
  resultNew: [],
  loading: false,
  error: null,
};

export function studentWithLicenseReducer(
  state = INIT_STUDENTS_LICENSES,
  action = {}
) {
  switch (action.type) {
    case "FETCH_STUDENTS_WITH_LICENSE_NEW_BEGIN": {
      return {
        ...state,
        loading: true,
        error: null,
        resultNew: [],
      };
    }
    case "FETCH_STUDENTS_WITH_LICENSE_NEW_FULFILLED": {
      return {
        ...state,
        loading: false,
        resultNew: action.payload,
      };
    }
    case "FETCH_STUDENTS_WITH_LICENSE_NEW_REJECTED": {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        resultNew: [],
      };
    }
    default: {
      return { ...state };
    }
  }
}
